import { PHONE_NUMBER, TOKEN, USER_TOKEN,MANUAL_TOKEN } from "../../Redux/types";

const intialState = {
  isUserLoggedIn: false
};
/* istanbul ignore next */
const user = (state = intialState, action) => {
  switch (action.type) {
    case PHONE_NUMBER:
      return {
        ...state,
        phone_number: action.payload.phone_number,
      };
    case TOKEN:
      return {
        ...state,
        access_token: action.payload,
      };
    case USER_TOKEN:
      return {
        ...state,
        User: action.payload,
        isUserLoggedIn: true
      };
      case MANUAL_TOKEN:
        return {
          ...state,
          manual_token:action.payload
        }
    default:
      return state;
  }
};

export default user;
